import { SavedForLaterClient } from "./SavedForLaterClient";

export default function SavedPage() {
  return <SavedForLaterClient />;
}
